export default "__VITE_ASSET__C$asv5Oy__"